import { render, staticRenderFns } from "./Revendedor.vue?vue&type=template&id=b7fde4fe&"
import script from "./Revendedor.vue?vue&type=script&lang=js&"
export * from "./Revendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports